import { createClient } from '@supabase/supabase-js';

// ─── Environment variable validation ─────────────────────────────────────────
const envSupabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// 🚀 NESSUN PROXY: Connessione vitale diretta e pulita
// Safely remove trailing slashes or dots from the URL to avoid SSL/fetch errors
const supabaseUrl = envSupabaseUrl ? envSupabaseUrl.replace(/[\.\/]+$/, '') : envSupabaseUrl;

if (!envSupabaseUrl || !supabaseAnonKey) {
  const missing = [
    !envSupabaseUrl && 'REACT_APP_SUPABASE_URL',
    !supabaseAnonKey && 'REACT_APP_SUPABASE_ANON_KEY',
  ].filter(Boolean).join(', ');

  console.error(
    `[supabaseClient] ❌ Missing environment variable(s): ${missing}.\n` +
    `Add them to /frontend/.env and restart the dev server.\n` +
    `In production, add them to your Vercel project settings.`
  );

  if (process.env.NODE_ENV === 'development') {
    window.addEventListener('DOMContentLoaded', () => {
      const banner = document.createElement('div');
      banner.style.cssText = [
        'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:99999',
        'background:#dc2626', 'color:#fff', 'font-family:monospace',
        'font-size:13px', 'padding:10px 16px', 'text-align:center',
        'box-shadow:0 2px 8px rgba(0,0,0,.4)',
      ].join(';');
      banner.textContent = `⚠️ Supabase not configured — missing: ${missing}. Add them to /frontend/.env.`;
      document.body.prepend(banner);
    });
  }
}

// ─── iOS/Safari-safe storage adapter ─────────────────────────────────────────
const iOSSafeStorage = (() => {
  const memoryStore = {};

  const tryLocalStorage = () => {
    try {
      const testKey = process.env.REACT_APP_STORAGE_PROBE_KEY || 'storage_probe_test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch {
      return null;
    }
  };

  const trySessionStorage = () => {
    try {
      const testKey = process.env.REACT_APP_STORAGE_PROBE_KEY || 'storage_probe_test';
      window.sessionStorage.setItem(testKey, '1');
      window.sessionStorage.removeItem(testKey);
      return window.sessionStorage;
    } catch {
      return null;
    }
  };

  const storage = tryLocalStorage() || trySessionStorage() || null;

  return {
    getItem: (key) => {
      try {
        if (storage) return storage.getItem(key);
        return memoryStore[key] ?? null;
      } catch {
        return memoryStore[key] ?? null;
      }
    },
    setItem: (key, value) => {
      try {
        if (storage) storage.setItem(key, value);
        else memoryStore[key] = value;
      } catch {
        memoryStore[key] = value;
      }
    },
    removeItem: (key) => {
      try {
        if (storage) storage.removeItem(key);
        delete memoryStore[key];
      } catch {
        delete memoryStore[key];
      }
    },
  };
})();

// ─── Client options (FIX PER SAFARI & iOS) ───────────────────────────────────
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: iOSSafeStorage, 
    storageKey: 'umf-newspaper-auth-session', 
    flowType: 'pkce', 
  },
});

export default supabase;
